import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { environment } from '@pg-env/environment';
import { BehaviorSubject, forkJoin, Observable, ReplaySubject, Subscription } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { RegistrationStep2Service } from '@pg-app/client/services/registrationStep2.service';
import { RoleNames } from '@pg-app/core/services/roles/RoleNames';

@Injectable({
  providedIn: 'root'
})
export class RolesService implements OnDestroy {
  public roles$ = new ReplaySubject<string[]>();
  public roleUpdates$ = new BehaviorSubject<string[]>(null);

  private api = environment.identityApiUrl;
  private customerApi = environment.customerApiUrl;
  reload = true;
  subscription: Subscription;

  constructor(private http: HttpClient, private registerStep2Service: RegistrationStep2Service) {
  }

  roleList$: Observable<any> = this.http.get<any>(this.api + '/account/get-user-roles').pipe(
    shareReplay(1),
  );

  accountInfo$: Observable<any> = this.http.get<any>(this.customerApi + '/customer/account-type').pipe(
    shareReplay(1),
  );

  getRolesfromAPI(forceUpdate = false): Observable<any> {
    if (forceUpdate) {
      this.roleList$ = this.http.get<any>(this.api + '/account/get-user-roles').pipe(
        shareReplay(1),
      );
    }
    return this.roleList$;
  }

  getAccountType(forceUpdate = false): Observable<any> {
    if (forceUpdate) {
      this.accountInfo$ = this.http.get<any>(this.customerApi + '/customer/account-type').pipe(
        shareReplay(1),
      );
    }
    return this.accountInfo$;
  }

  getRoles(roleName = '') {
    const update = this.reload;
    if (this.reload) {
      this.reload = false;
    }
    const roleList = this.getRolesfromAPI(update);
    const accountInfo = this.getAccountType(update);
    let roles = [];
    return new Promise(resolve => {
      this.subscription = forkJoin([roleList, accountInfo]).subscribe(res => {
        if (res[1].isReadOnly && res[1].accountNumber) {
          const viewReport = res[0].filter(item => item.name === RoleNames.VIEW_REPORT);
          if (viewReport) {
            roles = viewReport.map(item => item.name);
          }
        } else if (res[0] && res[0].length) {
          roles = res[0].map(item => item.name);
        }
        resolve(roles.indexOf(roleName) !== -1);
      });
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}


